import * as React from "react";
import { Accordion } from "../../../../../../../react-core/Html/Accordion";
import { MoneyTextBoxEditor } from "../../../../../../../react-core/Html/Money/MoneyTextBoxEditor";
import { NumberTextBoxEditor } from "../../../../../../../react-core/Html/NumberTextBoxEditor";
import { PercentageTextBoxEditor } from "../../../../../../../react-core/Html/PercentageTextBoxEditor";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { SippDrawdownType } from "../../../../../../../Wrap/Constants/Enums/Domain/SippDrawdownType";
import { CustomerPensionProtectionModel } from "../../../../../../../Wrap/Models/Domains/Drawdown/CustomerPensionProtectionModel";
import { DrawdownModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { Typography } from "../../../../../../Shared/Typography/Typography";
import { hasOtherEnhancementFactors, isRegualr, shouldShowUfplsErrorMessage } from "./Helper/DrawdownDetailHelper";
import {
    AllowanceDetailHeading,
    drawdownDetailsMessage,
    LTADetailHeading,
    LTADetailTooltiopMessage,
} from "./Resource/Contents";
import { PensionOption } from "../../../../../../../Wrap/Constants/Enums/Apply/PensionOption";

interface IAllowanceDetailsProps extends IProcessComponentProps {
    data: DrawdownModel;
    doCalculation: VoidFunction;
    hasEnhancedPensionProtection: boolean;
    pensionProtection: CustomerPensionProtectionModel;
    process: ProcessType;
}

interface IAllowanceDetailsState { }

export class AllowanceDetails extends ProcessComponent<IAllowanceDetailsProps, IAllowanceDetailsState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public componentDidUpdate(prevProps: IAllowanceDetailsProps): void {
        const {pensionProtection, data} = this.props;

        if (!this.shouldDisplayOffPlatformAllowanceAsAt05042024(pensionProtection, data?.AllowanceDetails?.HasOffPlatformBcePriorApril2024, data?.AllowanceDetails?.AwareOfBCEAmounts)) {
            if(data?.AllowanceDetails?.LumpSumAllowanceOffPlatformAsAt05042024?.Amount > 0){
                data.AllowanceDetails.LumpSumAllowanceOffPlatformAsAt05042024.Amount = 0;
            }

            if(data?.AllowanceDetails?.LumpSumDeathBenefitAllowanceOffPlatformAsAt05042024?.Amount > 0){
                data.AllowanceDetails.LumpSumDeathBenefitAllowanceOffPlatformAsAt05042024.Amount = 0;
            }
        }
    }

    private renderlsaOtherUsedAsAt5April2024AmountNumberTextBox(amount): JSX.Element {
        const { data, onChange } = this.props;
        return (
            <MoneyTextBoxEditor
                cssWrapper="control-size-115"
                isNotForm={true}
                currency={CurrencyCode.GBP}
                maxNumberOfDecimalPlaces={{
                    errorMessage: "Expected value to 2dp.Please re-enter",
                    value: 2,
                }}
                value={amount ?? 0}
                alwaysValidateOnUpdate={true}
                onChange={(v) => {
                    this.onDataChange(
                        onChange,
                        { LumpSumAllowanceOffPlatformAsAt05042024: { Amount: v ? Number(v.toFixed(2)) : 0, Currency: CurrencyCode.GBP } },
                        data,
                        "AllowanceDetails"
                    );
                }}
            // onBlur={(v) => this.props.doCalculation()}
            />
        );
    }

    private renderlsaOtherUsedOnOrAfter6April2024AmountNumberTextBox(amount): JSX.Element {
        const { data, onChange } = this.props;
        return (
            <MoneyTextBoxEditor
                cssWrapper="control-size-115"
                currency={CurrencyCode.GBP}
                isNotForm={true}
                maxNumberOfDecimalPlaces={{
                    errorMessage: "Expected value to 2dp.Please re-enter",
                    value: 2,
                }}
                value={amount ?? 0}
                alwaysValidateOnUpdate={true}
                onChange={(v) => {
                    this.onDataChange(
                        onChange,
                        { LumpSumAllowanceOffPlatformAfter06042024: { Amount: v ? Number(v.toFixed(2)) : 0, Currency: CurrencyCode.GBP } },
                        data,
                        "AllowanceDetails"
                    );
                }}
            onBlur={(v) => this.props.doCalculation()}
            />
        );
    }

    private renderlsdbaOtherLSDBAUsedAsAt5April2024AmountNumberTextBox(amount): JSX.Element {
        const { data, onChange } = this.props;
        return (
            <MoneyTextBoxEditor
                cssWrapper="control-size-115"
                currency={CurrencyCode.GBP}
                isNotForm={true}
                maxNumberOfDecimalPlaces={{
                    errorMessage: "Expected value to 2dp.Please re-enter",
                    value: 2,
                }}
                value={amount ?? 0}
                alwaysValidateOnUpdate={true}
                onChange={(v) => {
                    this.onDataChange(
                        onChange,
                        { LumpSumDeathBenefitAllowanceOffPlatformAsAt05042024: { Amount: v ? Number(v.toFixed(2)) : 0, Currency: CurrencyCode.GBP } },
                        data,
                        "AllowanceDetails"
                    );
                }}
            onBlur={(v) => this.props.doCalculation()}
            />
        );
    }

    private renderlsdbaOtherLSDBAUsedOnOrAfter6April2024AmountTextBox(amount): JSX.Element {
        const { data, onChange } = this.props;
        return (
            <MoneyTextBoxEditor
                cssWrapper="control-size-115"
                currency={CurrencyCode.GBP}
                isNotForm={true}
                maxNumberOfDecimalPlaces={{
                    errorMessage: "Expected value to 2dp.Please re-enter",
                    value: 2,
                }}
                value={amount ?? 0}
                alwaysValidateOnUpdate={true}
                onChange={(v) => {
                    this.onDataChange(
                        onChange,
                        { LumpSumDeathBenefitAllowanceOffPlatformAfter06042024: { Amount: v ? Number(v.toFixed(2)) : 0, Currency: CurrencyCode.GBP } },
                        data,
                        "AllowanceDetails"
                    );
                }}
                onBlur={(v) => this.props.doCalculation()}
            />
        );
    }

    private renderisPartOfUsedSIHBefore75Radios(isPartOfUsedSIHBefore75): JSX.Element {
        const { data, onChange } = this.props;
        return (
            <RadiosEditor
                cssWrapper="radio-group rg-150 mb-23"
                selected={isPartOfUsedSIHBefore75?? false}
                options={[true, false]}
                getText={(v) => {
                    return v ? "Yes" : "No";
                }}
                onChange={(v) => {
                    this.onDataChange(
                        onChange,
                        { LumpSumDeathBenefitAllowanceUsedSeriousIllHealthBefore75: v },
                        data,
                        "AllowanceDetails"
                    );
                }}
            />
        );
    }

    private renderhasTakenIllHealthLumpSumRadios(hasSeriousIllHealthTaken): JSX.Element {
        const { data, onChange } = this.props;
        return (
            <RadiosEditor
                cssWrapper="radio-group rg-150 mb-23"
                selected={hasSeriousIllHealthTaken?? false}
                options={[true, false]}
                getText={(v) => {
                    return v ? "Yes" : "No";
                }}
                onChange={(v) =>
                    { this.onDataChange(
                    onChange,
                    { HasSeriousIllHealthTaken: v },
                    data
                );}
            }
            />
        );
    }

    private hasPrimaryProtection = (pensionProtection: CustomerPensionProtectionModel) => {
        return (pensionProtection?.Primary?.HasProtection)
    };

    private hasPrimaryPCLSProtection = (pensionProtection: CustomerPensionProtectionModel) => {
        return (pensionProtection?.Primary?.ProtectionAmount)
    };

    private hasEnhancedProtection = (pensionProtection: CustomerPensionProtectionModel) => {
        return (pensionProtection?.Enhanced?.HasProtection)
    };

    private hasEnhancedPCLSProtection = (pensionProtection: CustomerPensionProtectionModel) => {
        return (pensionProtection?.Enhanced?.EntitlementPercentage)
    };

    private hasTransitionalTaxFreeAllowanceCertificate = (pensionProtection: CustomerPensionProtectionModel) => {
        return (pensionProtection?.TransitionalLumpSum?.HasProtection)
    };

    private shouldDisplayOffPlatformAllowanceAsAt05042024 = (pensionProtection: CustomerPensionProtectionModel, hasOffPlatformBcePriorApril2024: boolean, awareOfBCEAmounts: boolean) => {
        return (!this.hasTransitionalTaxFreeAllowanceCertificate(pensionProtection) && hasOffPlatformBcePriorApril2024 && awareOfBCEAmounts) || (this.hasEnhancedProtection(pensionProtection) && this.hasEnhancedPCLSProtection(pensionProtection))
        || (this.hasPrimaryProtection(pensionProtection) && this.hasPrimaryPCLSProtection(pensionProtection) && hasOffPlatformBcePriorApril2024 && awareOfBCEAmounts)
    };

    private initializeDefaultGBPCurrency = ( data: DrawdownModel) => {
        if (data?.AllowanceDetails?.LumpSumAllowanceOffPlatformAsAt05042024?.Currency == CurrencyCode.NotSpecified) {
            data.AllowanceDetails.LumpSumAllowanceOffPlatformAsAt05042024.Currency = CurrencyCode.GBP
        }

        if (data?.AllowanceDetails?.LumpSumAllowanceOffPlatformAfter06042024?.Currency == CurrencyCode.NotSpecified) {
            data.AllowanceDetails.LumpSumAllowanceOffPlatformAfter06042024.Currency = CurrencyCode.GBP
        }

        if (data?.AllowanceDetails?.LumpSumDeathBenefitAllowanceOffPlatformAsAt05042024?.Currency == CurrencyCode.NotSpecified) {
            data.AllowanceDetails.LumpSumDeathBenefitAllowanceOffPlatformAsAt05042024.Currency = CurrencyCode.GBP
        }

        if (data?.AllowanceDetails?.LumpSumDeathBenefitAllowanceOffPlatformAfter06042024?.Currency == CurrencyCode.NotSpecified) {
            data.AllowanceDetails.LumpSumDeathBenefitAllowanceOffPlatformAfter06042024.Currency = CurrencyCode.GBP
        }
    }

    private renderAllowanceDetails(): JSX.Element {
        const { data, pensionProtection,process } = this.props;
        const AllowanceLSADetails = [];
        const AllowanceLSDBADetails = [];

        this.initializeDefaultGBPCurrency(data);

        const showLumpSumMessageForUFPLS = shouldShowUfplsErrorMessage(pensionProtection, data);

        if (!this.hasTransitionalTaxFreeAllowanceCertificate(pensionProtection) || (this.hasEnhancedProtection(pensionProtection) && this.hasEnhancedPCLSProtection(pensionProtection))
            || (this.hasPrimaryProtection(pensionProtection) && this.hasPrimaryPCLSProtection(pensionProtection))) {
            AllowanceLSADetails.push({
                title: AllowanceDetailHeading.lsaUsedAsAt5April2024Amount,
                data: "£" + (data?.DrawdownCalculations?.LumpSumAllowance?.UsedBefore2024?.Amount ?? 0).toFixed(2),
            });
        }
        AllowanceLSADetails.push({
            title: AllowanceDetailHeading.lsaUsedOnOrAfter6April2024Amount,
            data: "£" + (data?.DrawdownCalculations?.LumpSumAllowance?.UsedAfter2024?.Amount ?? 0).toFixed(2),
        });
        if (!this.hasTransitionalTaxFreeAllowanceCertificate(pensionProtection) || (this.hasEnhancedProtection(pensionProtection) && this.hasEnhancedPCLSProtection(pensionProtection))
            | (this.hasPrimaryProtection(pensionProtection) && this.hasPrimaryPCLSProtection(pensionProtection))) {
            AllowanceLSADetails.push({
                title: AllowanceDetailHeading.lsaUsedBefore6April2006Amount,
                data: "£" + (data?.DrawdownCalculations?.LumpSumAllowance?.UsedBefore2006?.Amount ?? 0).toFixed(2),
            });

        }
        if (this.shouldDisplayOffPlatformAllowanceAsAt05042024(pensionProtection, data?.AllowanceDetails?.HasOffPlatformBcePriorApril2024, data?.AllowanceDetails?.AwareOfBCEAmounts)) { 
            AllowanceLSADetails.push({
                title: AllowanceDetailHeading.lsaOtherUsedAsAt5April2024Amount,
                data: this.renderlsaOtherUsedAsAt5April2024AmountNumberTextBox(
                    data?.AllowanceDetails?.LumpSumAllowanceOffPlatformAsAt05042024?.Amount
                ),
            });
        }

        AllowanceLSADetails.push({
            title: AllowanceDetailHeading.lsaOtherUsedOnOrAfter6April2024Amount,
            data: this.renderlsaOtherUsedOnOrAfter6April2024AmountNumberTextBox(
                data?.AllowanceDetails?.LumpSumAllowanceOffPlatformAfter06042024?.Amount
            ),
        });

        if (isRegualr(data)) {
            var initialCrystallisation =
                data.DrawdownCalculations?.LumpSumAllowance?.UsedByInitialCrystallisation?.Amount != null
                    ? data?.DrawdownCalculations?.LumpSumAllowance?.UsedByInitialCrystallisation.Amount.toFixed(2)
                    : 0;
            AllowanceLSADetails.push(
                {
                    title: AllowanceDetailHeading.lsaUsedByInitialCrystallisation,
                    data: "£" + initialCrystallisation,
                },
                {
                    title: AllowanceDetailHeading.lsaUsedByRegularCrystallisation,
                    data: "£" + (data?.DrawdownCalculations?.LumpSumAllowance?.UsedByCrystallisation?.Amount ?? 0).toFixed(2),
                },
                {
                    title: AllowanceDetailHeading.lsaUsedFollowingBycrystallisation,
                    data: "£" + (data?.DrawdownCalculations?.LumpSumAllowance?.UsedTotal?.Amount ?? 0).toFixed(2),
                }
            );
        } else {
            AllowanceLSADetails.push(
                {
                    title: AllowanceDetailHeading.lsaUsedBycrystallisation,
                    data: "£" + (data?.DrawdownCalculations?.LumpSumAllowance?.UsedByCrystallisation?.Amount ?? 0).toFixed(2),
                },
                {
                    title: AllowanceDetailHeading.lsaUsedFollowingBycrystallisation,
                    data: "£" + (data?.DrawdownCalculations?.LumpSumAllowance?.UsedTotal?.Amount ?? 0).toFixed(2),
                }
            );
        }

        if (!this.hasTransitionalTaxFreeAllowanceCertificate(pensionProtection) || (this.hasEnhancedProtection(pensionProtection) && this.hasEnhancedPCLSProtection(pensionProtection))
            || (this.hasPrimaryProtection(pensionProtection) && this.hasPrimaryPCLSProtection(pensionProtection))) {
            AllowanceLSDBADetails.push({
                title: AllowanceDetailHeading.lsdbaUsedLSDBAAsAt5April2024Amount,
                data: "£" + (data?.DrawdownCalculations?.LumpSumDeathBenefitAllowance?.UsedBefore2024?.Amount ?? 0).toFixed(2),
            });
        }

        AllowanceLSDBADetails.push({
            title: AllowanceDetailHeading.lsdbaUsedLSDBAOnOrAfter6April2024Amount,
            data: "£" + (data?.DrawdownCalculations?.LumpSumDeathBenefitAllowance?.UsedAfter2024?.Amount ?? 0).toFixed(2),
        });

        if (!this.hasTransitionalTaxFreeAllowanceCertificate(pensionProtection) || (this.hasEnhancedProtection(pensionProtection) && this.hasEnhancedPCLSProtection(pensionProtection))
            || (this.hasPrimaryProtection(pensionProtection) && this.hasPrimaryPCLSProtection(pensionProtection))) {
            AllowanceLSDBADetails.push({
                title: AllowanceDetailHeading.lsdbaUsedLSDBABefore6April2006Amount,
                data: "£" + (data?.DrawdownCalculations?.LumpSumDeathBenefitAllowance?.UsedBefore2006?.Amount ?? 0).toFixed(2),
            });

        }

        if (this.shouldDisplayOffPlatformAllowanceAsAt05042024(pensionProtection, data?.AllowanceDetails?.HasOffPlatformBcePriorApril2024, data?.AllowanceDetails?.AwareOfBCEAmounts)) { 
            AllowanceLSDBADetails.push(
                {
                    title: AllowanceDetailHeading.lsdbaOtherLSDBAUsedAsAt5April2024Amount,
                    data: this.renderlsdbaOtherLSDBAUsedAsAt5April2024AmountNumberTextBox(
                        data?.AllowanceDetails?.LumpSumDeathBenefitAllowanceOffPlatformAsAt05042024?.Amount
                    ),
                },
                {
                    title: AllowanceDetailHeading.isPartOfUsedSIHBefore75,
                    data: this.renderisPartOfUsedSIHBefore75Radios(
                        data?.AllowanceDetails?.LumpSumDeathBenefitAllowanceUsedSeriousIllHealthBefore75
                    ),
                }
            );
        }

        AllowanceLSDBADetails.push({
            title: AllowanceDetailHeading.lsdbaOtherLSDBAUsedOnOrAfter6April2024Amount,
            data: this.renderlsdbaOtherLSDBAUsedOnOrAfter6April2024AmountTextBox(
                data?.AllowanceDetails?.LumpSumDeathBenefitAllowanceOffPlatformAfter06042024?.Amount
            ),
        });
        if ((this.hasEnhancedProtection(pensionProtection) && !this.hasEnhancedPCLSProtection(pensionProtection))) {
            AllowanceLSDBADetails.push({
                title: AllowanceDetailHeading.hasTakenIllHealthLumpSum,
                data: this.renderhasTakenIllHealthLumpSumRadios(data.HasSeriousIllHealthTaken),
            });
        }

        if (isRegualr(data)) {
            var lsdbaUsedByInitialCrystallisation = data?.DrawdownCalculations?.LumpSumDeathBenefitAllowance
                ?.UsedByInitialCrystallisation?.Amount
                ? data?.DrawdownCalculations?.LumpSumDeathBenefitAllowance?.UsedByInitialCrystallisation?.Amount.toFixed(2) : 0;
            AllowanceLSDBADetails.push(
                {
                    title: AllowanceDetailHeading.lsdbaUsedByInitialCrystallisation,
                    data: "£" + lsdbaUsedByInitialCrystallisation,
                },
                {
                    title: AllowanceDetailHeading.lsdbaUsedByRegularCrystallisation,
                    data: "£" + (data?.DrawdownCalculations?.LumpSumDeathBenefitAllowance?.UsedByCrystallisation?.Amount ?? 0).toFixed(2),
                },
                {
                    title: AllowanceDetailHeading.lsdbaUsedFollowingBycrystallisation,
                    data: "£" + (data?.DrawdownCalculations?.LumpSumDeathBenefitAllowance?.UsedTotal?.Amount ?? 0).toFixed(2),
                }
            );
        } else
            AllowanceLSDBADetails.push(
                {
                    title: AllowanceDetailHeading.lsdbaUsedBycrystallisation,
                    data: "£" + (data?.DrawdownCalculations?.LumpSumDeathBenefitAllowance?.UsedByCrystallisation?.Amount ?? 0).toFixed(2),
                },
                {
                    title: AllowanceDetailHeading.lsdbaUsedFollowingBycrystallisation,
                    data: "£" + (data?.DrawdownCalculations?.LumpSumDeathBenefitAllowance?.UsedTotal?.Amount ?? 0).toFixed(2),
                }
            );
        return (
            <>
                <Accordion label="Allowance details" cssWrapper="accordion-with-arrow" isOpen={true}>
                    <span className="title">{AllowanceDetailHeading.lsaDetails}</span>
                    <Typography type="has-long-labels" wrapCss="dt-bold pt-12" config={AllowanceLSADetails} />
                    <span className="title">{AllowanceDetailHeading.lsdbaDetails}</span>
                    <Typography type="has-long-labels" wrapCss="dt-bold pt-12" config={AllowanceLSDBADetails} />
                </Accordion>
                {showLumpSumMessageForUFPLS &&
                    (<>
                        <div className="title">
                            Maximum amount of UFPLS that can be taken is {data?.DrawdownCalculations?.MaximumUfplsAvailable?.Amount ?? 0}, please reduce the crystallisation amount
                        </div>
                    </>)
                }
            </>
        );
    }

    public render(): JSX.Element {
        return <>{this.renderAllowanceDetails()}</>;
    }
}
